import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.PEDIDO.DOCUMENTOS.ANEXO.CRIAR](context, documentoComAnexo) {
		const { data } = await api.documentosPedidoAnexo.adicionarAnexo(documentoComAnexo)
		return data
	},
}
